import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import CounterCustomerChargeMaintenanceCont from "presentation/view/container/CounterCustomerCharge/CounterCustomerChargeContMain";

CommonEntrypoint(<CounterCustomerChargeMaintenanceCont/>)